import React from 'react'
import { graphql } from 'gatsby'
import Helmet from 'react-helmet'
import { SinglePageQuery, Html } from 'generated/types/gatsby'
import { Layout } from '../components/layout/Layout'
import '../styles/main.scss'
import '../styles/ui/typography.scss'
import { WindowLocation } from '@reach/router'

interface ContentTemplateProps {
  readonly data: SinglePageQuery
  readonly pageContext: {
    documentName: string
    productName: string
    slugRegex: string
    prev: Html
    next: Html
  }
  readonly location: WindowLocation<{ scrollTop: number; query: string }>
}

const ContentTemplate = ({ data, pageContext, location }: ContentTemplateProps) => {
  const { scrollTop, query } = location?.state || 0
  const {
    html: { frontmatter, html },
    allHtml: { group },
    allMdx: { edges },
  } = data
  const { productName, documentName, ...prevAndNext } = pageContext

  const currentDocument = edges
    .find((edge) => edge.node.frontmatter.title === productName)
    ?.node.frontmatter.links.find((link) => link.path.startsWith(documentName))

  return (
    <Layout
      contentNavData={group}
      activeSection={frontmatter}
      productName={productName}
      currentDocument={currentDocument}
      scrollTop={scrollTop}
      prevAndNext={prevAndNext}
      searchQuery={query}
    >
      <Helmet title={`${frontmatter.title}`} />
      <div className="la-post" dangerouslySetInnerHTML={{ __html: html }} />
    </Layout>
  )
}

export default ContentTemplate

export const query = graphql`
  query SinglePage($path: String!, $slugRegex: String!) {
    html(frontmatter: { slug: { eq: $path } }) {
      html
      frontmatter {
        slug
        title
        sectionName
        chapterName
      }
    }
    allHtml(
      sort: { fields: [frontmatter___sectionNumber, frontmatter___articleNumber] }
      filter: { frontmatter: { slug: { regex: $slugRegex } } }
    ) {
      group(field: frontmatter___sectionNumber) {
        edges {
          node {
            frontmatter {
              sectionNumber
              sectionName
              title
              slug
              documentNumber
              articleNumber
              chapterName
            }
          }
        }
      }
    }
    allMdx(filter: { fields: { sourceName: { eq: "cards" } } }) {
      edges {
        node {
          frontmatter {
            title
            links {
              header
              path
              pdf
              title
            }
          }
        }
      }
    }
  }
`
